var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.294 10.85L5.759 7.313l-3.535 3.535a.998.998 0 01-1.632-.325 1 1 0 01.217-1.09L4.345 5.9.809 2.364A1 1 0 112.224.95l3.535 3.535L9.294.95a.998.998 0 011.415 0 1 1 0 010 1.414L7.174 5.899l3.535 3.535a.997.997 0 01.217 1.09 1.001 1.001 0 01-1.632.325z"
  })));
}
export default SvgClose;